import { useChatAttention } from './useChatAttention.js';
export function ChatNavBadge() {
  const { data } = useChatAttention();
  const count = data ? data.global + data.private + data.requests : 0;
  return count > 0 ? (
    <b className="nav-attention-badge" aria-label={`Новое в чате: ${count}`}>
      {count > 99 ? '99+' : count}
    </b>
  ) : null;
}
